import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { COMMON_NS } from "./common/common.i18n";
import { Translations } from "./translations";
import { pseudo } from "./utils/pseudo/pseudo";

const FALLBACK_LNG = "en";

const postProcessors = [];

if (
  process.env.NODE_ENV === "development" &&
  import.meta.env.VITE_ENABLE_I18N_PSEUDO
) {
  postProcessors.push(pseudo.name);
}

i18n
  .use(pseudo)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: "en",
    resources: Translations,
    fallbackNS: COMMON_NS,
    fallbackLng: FALLBACK_LNG,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    postProcess: postProcessors,
  });

export default i18n;
